import request from '@/api/httpRequest2'

// 查询文档列表
export function listDocument(query) {
  return request({
    url: '/klgeek/document/list',
    method: 'get',
    params: query
  })
}

// 查询文档详细
export function getDocument(id) {
  return request({
    url: '/klgeek/document/' + id,
    method: 'get'
  })
}

// 新增文档
export function addDocument(data) {
  return request({
    url: '/klgeek/document',
    method: 'post',
    data: data
  })
}

// 修改文档
export function updateDocument(data) {
  return request({
    url: '/klgeek/document',
    method: 'put',
    data: data
  })
}

// 删除文档
export function delDocument(id) {
  return request({
    url: '/klgeek/document/' + id,
    method: 'delete'
  })
} 
// 查询目录下的文档列表
export function listDocumentsByDirectory(directoryId, knowledgeId) {
    return request({
      url: '/klgeek/document/list',
      method: 'get',
      params: {
        directoryId,
        knowledgeId
      }
    });
  } 